"use client";
import styled from "styled-components";
import {LuDoorOpen} from "react-icons/lu";
import {FaRegSadTear} from "react-icons/fa";
import {useRouter} from "next/navigation";
import {SIZES} from "@/components/constants";
import {getNavigationStore} from "@/store/homepage/NavigationStore";
import {useEffect} from "react";

export default function NotFound() {
    const router = useRouter();
    useEffect(() => {
        const prevTitle = document.title;
        document.title = "404 Not Found";
        return () => {
            document.title = prevTitle;
        };
    }, []);
    return (
        <Wrap>
            <ErrorContainer>
                <div className={"error-message"}>
                    <FaRegSadTear size={50} color={"#246ff2"} />
                    <p>404 Not Found</p>
                    <span>
                    요청하신 페이지가 존재하지 않습니다.
                </span>
                </div>
                <div className={"to-home"}>
                    <div className={"inner"}
                         onClick={()=>{
                             getNavigationStore().setClearNavigation();
                             router.push("/homepage");
                         }}
                    >
                        <LuDoorOpen color={"#fff"} size={20}/> <span>홈으로 돌아가기</span>
                    </div>
                </div>
            </ErrorContainer>
        </Wrap>
    );
}

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    background: #fff;
    position: relative;
`;

const ErrorContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    .error-message {
        text-align: center;

        p {
            color: #246ff2;
            font-weight: 900;
            font-size: 45px;
            margin: 20px 0;
            font-family: 'Lato', sans-serif;
        }

        span {
            font-size: 25px;
            line-height: 1.25;
        }
    }
    .to-home{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .inner{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 160px;
            background-color: #246ff2;
            height: 40px;
            border-radius: 20px;
            cursor: pointer;
            span{
                color: #fff;
                display: block;
                line-height: .2;
                margin-left: 6px;
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .error-message {
            text-align: center;
            p {
                font-size: 30px;
            }
            span {
                font-size: 14px;
            }
        }
    }
`;